import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../../http";
import Spinner from "../../Spinner";
import HeaderWrapper from "../../Header/HeaderWrapper";
import FooterWrapper from "../../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../../Helper/Helper";
import TextMainBannerWrapper from "../../TextMainBanners/TextMainBannerWrapper";

function MasonryShowcaseServicesListing() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [isLoading, setIsLoading] = useState(true);
  const [isData, setIsdata] = useState(false);
  const [servicesData, setServicesData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getServicesData();
  }, []);

  const getServicesData = async () => {
    const response = await SendPostRequest("services/list");
    setIsLoading(false);

    if (!response?.data || response?.data?.length < 1) {
      setIsdata(true);
    } else {
      setServicesData(response.data);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />

        <TextMainBannerWrapper
          Heading={sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
          Image="theme-2-banner-speciality.webp"
        />


        <div
          id="portfolio-section"
          className="portfolio-section py-4 my-0 section-bg-img"
        // style={{ backgroundImage: `url(/assets/images/mist/specialities-masonry-showcase-bg.webp)` }}
        >
          <div >
            {sitedata?.site_type === "hospitals" ? (
              <div className="row mt-5">
                <div className="offset-md-2 col-md-8">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-60">
                      <h2 className="section-title mb-0 text-uppercase">
                        Provides Our{" "}
                        <span className="theme-color">Best Specialties</span>
                      </h2>
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="mt-5"></div>
            )}

            <div
              className="row  portfolio-wrap portfolio-classic-pro px-4 my-3"
              data-animation="fadeInDown"
            >
              {isLoading ? (
                <div className="col-12 text-center">
                  <Spinner />
                </div>
              ) : isData ? (
                <div className="col-12 text-center mb-4">
                  <h4>No Record Available</h4>
                </div>
              ) : (
                servicesData.map((service, index) => (
                  <div
                    className="portfolio-item portfolio-overlay-wrap col-lg-4 col-md-4 col-sm-4 col-xs-6 filter web"
                    key={index}
                  >
                    <div className="portfolio-thumb relative">
                      <Link
                        to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                          .replaceAll(" ", "-")
                          .replaceAll("/", "-")}`}
                      >
                        <img
                          src={service?.service_image_url}
                          className="img-fluid"
                          alt={service?.title}
                          title={service?.service_title}
                          style={{ height: "auto" }}
                        />
                      </Link>
                      <div className="portfolio-wrap mansory-services-mobile-view">
                        <div className="portfolio-details-overlay typo-white">
                          <h3 className="mb-2">
                            <Link
                              to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                .replaceAll(" ", "-")
                                .replaceAll("/", "-")}`}
                            >
                              {service?.service_title}
                            </Link>
                          </h3>
                          <div
                            className="portfolio-content w-75"
                            dangerouslySetInnerHTML={{
                              __html:
                                limitParagraphByCharLimit(service?.service_description, 80) +
                                (service?.service_description?.length > 80 ? "..." : ""),
                            }}
                          />
                        </div>
                        <div className="portfolio-icons">
                          <Link
                            to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                              .replaceAll(" ", "-")
                              .replaceAll("/", "-")}`}
                            className="link-icon"
                          >
                            <i className="icon-link"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <FooterWrapper />
      </div>
    </div>
  );
}

export default MasonryShowcaseServicesListing;
